import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import { fetchDataSheetDownloadUrl } from '../../../../states/containers/export/exportSlice'
import { setPath } from '../../../../utils/url'
import { URL } from '../../../constants/url'
import { RootState } from '../../../../states/containers/store'

const Download: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { id } = useParams<{ id: string }>()

  const {
    commonPart,
  } = useSelector((state: RootState) => (state))

  useEffect(() => {
    if (!id) return
    dispatch(
      fetchDataSheetDownloadUrl(
        Number(id),
        (url) => {
          window.location.href = url
          history.push({ pathname: setPath(URL.DATA_SHEET_EXPORT.path, commonPart.language as string), state: true })
        },
      ),
    )
  }, [])

  return (
    <>
      <Helmet>
        <title>Qasee - 組織分析 - データエクスポート - 比較データダウンロードリンク</title>
      </Helmet>
    </>
  )
}
export default Download
